export const TOGGLE_MOBILE = 'toggle mobile'

export function toggleMobile(){
    return function(dispatch, getState){
        dispatch({
            type : TOGGLE_MOBILE
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/mobile.action.js